export default __webpack_public_path__ + "static/media/image.echonlabs-private-limited.9f6c3c97.png";